/** Sitelane design tokens (from reference HTML/CSS) */
export const PLAN = {
  bg: "#F6F8FB",
  surface: "#FFFFFF",
  sunken: "#EEF2F7",
  border: "#E5E9F0",
  borderStrong: "#D6DCE5",
  primary: "#2B6CFF",
  primaryHover: "#1F4ED1",
  primarySoft: "#E6EFFF",
  text: "#0F172A",
  ink: "#0B1220",
  textSecondary: "#364152",
  muted: "#6B7682",
  mutedLight: "#9AA3AF",
  ok: "#10B981",
  warn: "#F59E0B",
  danger: "#EF4444",
  proj1: "#2B6CFF",
  proj2: "#7C5CFF",
  proj3: "#FF8A3D",
  proj4: "#10A37F",
  proj5: "#D946A5",
  radius: "12px",
  radiusSm: "8px",
};

export const planSurfaceClass =
  "rounded-[10px] border border-[#E5E9F0] bg-white shadow-[0_1px_2px_rgba(15,23,42,0.04)]";

export const planPrimaryBtnClass = "pp-btn pp-btn-primary";

export const planGhostBtnClass = "pp-btn";

export const planSegmentActiveClass =
  "rounded-[7px] bg-white px-3 py-1.5 text-[13px] font-medium text-[#0B1220] shadow-[0_1px_2px_rgba(15,23,42,0.04)]";

export const planSegmentIdleClass =
  "rounded-[7px] border-0 bg-transparent px-3 py-1.5 text-[13px] text-[#364152] hover:text-[#0B1220]";
